import { AxiosResponse } from "axios";
import { BASE_URL, NAV_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/order-cart`;

//#region Co Discount Type
const getCoDiscoutType = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/credit-memo-type`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createCoDiscoutType = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/credit-memo-type/create`, params)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getCoDiscoutTypeById = async (id: string) => {
  return await httpClient
    .get(`${baseUrl}/credit-memo-type/${id}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateCoDiscoutType = async (params: object) => {
  return await httpClient
    .patch(`${baseUrl}/credit-memo-type`, params)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const deleteCoDiscoutTypeById = async (id: string) => {
  return await httpClient
    .delete(`${baseUrl}/credit-memo-type/${id}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const checkCodeColor = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/credit-memo-type/check-color`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const checkCodeCOType = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/credit-memo-type/check-code`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getUseageSummary = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/credit-memo-type/usage-summary`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getUseageById = async (params: {
  credit_memo_type_id: string;
  page: number;
  take: number;
  status?: string;
  search?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/credit-memo-type/${params.credit_memo_type_id}/credit-memos`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getCreditMemosById = async (params: {
  credit_memo_type_id: string;
  page: number;
  take: number;
  status?: string;
  search?: string;
  zone?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/credit-memo-type/${params.credit_memo_type_id}/shops`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const deleteAttachmentById = async (params: { coId: string; updateBy: string }) => {
  console.log("param", params);
  return await httpClient
    .delete(`${baseUrl}/co-management/${params.coId}/attachment`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
//#endregion

//#region Co Discount List
const getCoDiscountList = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/co-management`, { params })
    .then((res: AxiosResponse) => res.data.responseData)
    .catch((err) => console.log(err));
};
const getCoDiscountSummary = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/co-management/summary`, { params })
    .then((res: AxiosResponse) => res.data.responseData)
    .catch((err) => console.log(err));
};
const createCoDiscoutList = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/co-management/create`, params)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateCoDiscoutList = async (params: any) => {
  return await httpClient
    .patch(`${baseUrl}/co-management/${params.coId}`, {
      coId: params.coId,
      updatedBy: params.updatedBy,
      ...params,
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getCoDiscountById = async (id: string) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${id}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailCoDiscountById = async (id: string) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${id}/detail`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createCoAttachment = async (coId: string, params: { file: File; updateBy: string }) => {
  const formData = new FormData();
  formData.append("file", params.file);
  formData.append("updateBy", params.updateBy);
  return await httpClient
    .post(`${baseUrl}/co-management/${coId}/attachment`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getCoAttachment = async (coId: string) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${coId}/attachment`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const deleteCoDiscoutListById = async (id: string, updateBy: string) => {
  return await httpClient
    .delete(`${baseUrl}/co-management/${id}`, { params: { coId: id, updateBy } })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailShopById = async (params: {
  coId: string;
  page: number;
  take: number;
  amountMin?: number;
  amountMax?: number;
  search?: string;
  zone?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${params.coId}/shops`, {
      params: {
        page: params.page,
        take: params.take,
        amountMin: params.amountMin,
        amountMax: params.amountMax,
        search: params.search,
        zone: params.zone,
      },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailProductById = async (params: {
  coId: string;
  page: number;
  take: number;
  search?: string;
  productGroup?: string;
  strategyGroup?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${params.coId}/products`, {
      params: {
        page: params.page,
        take: params.take,
        search: params.search,
        productGroup: params.productGroup,
        strategyGroup: params.strategyGroup,
      },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailHistoryById = async (params: {
  coId: string;
  page: number;
  take: number;
  search?: string;
  zone?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${params.coId}/usage-history`, {
      params: { page: params.page, take: params.take, search: params.search, zone: params.zone },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailAdjustById = async (params: {
  coId: string;
  page: number;
  take: number;
  search?: string;
  type?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${params.coId}/adjustments`, {
      params: { page: params.page, take: params.take, search: params.search, type: params.type },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getCoDiscountHistoryById = async (params: { coId: string; page: number; take: number }) => {
  return await httpClient
    .get(`${baseUrl}/co-management/${params.coId}/audit-history`, {
      params: { page: params.page, take: params.take },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const checkCoConflicts = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/co-management/check-conflicts`, params)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateStatusShopWithRemark = async (params: any) => {
  return await httpClient
    .patch(`${baseUrl}/co-management/${params.coId}/shop/${params.coShopId}/status`, {
      coId: params.coId,
      coShopId: params.coShopId,
      ...params,
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateStatusMainWithRemark = async (params: any) => {
  return await httpClient
    .patch(`${baseUrl}/co-management/${params.coId}/status`, {
      coId: params.coId,
      coShopId: params.coShopId,
      ...params,
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
//#endregion

//#region Co Discount Each Shop
const getCoDiscountEachShop = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/co-management/shops`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getCoSummaryEachShop = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/co-management/shops/summary`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getShopCoListByShopId = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/co-management/shop-overview`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailShopCoByCusComId = async (params: { customerCompanyId: string }) => {
  return await httpClient
    .get(`${baseUrl}/co-management/customer/${params.customerCompanyId}/detail`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailShopCoList = async (params: {
  customerCompanyId: string;
  page: number;
  take: number;
  creditMemoTypeId?: string | null;
  search?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/co-management/customer/${params.customerCompanyId}/cos`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailShopHistoryList = async (params: {
  customerCompanyId: string;
  page: number;
  take: number;
  creditMemoTypeId?: string | null;
  search?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/co-management/customer/${params.customerCompanyId}/usage-history`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDetailShopAdjustmentList = async (params: {
  customerCompanyId: string;
  page: number;
  take: number;
  type?: string | null;
  search?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/co-management/customer/${params.customerCompanyId}/adjustments`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createAdjustCoShop = async (
  params: { coShopId: string; updateBy: string; type: string; amount: string; reason: string },
  fileRef: any,
) => {
  const formData = new FormData();
  formData.append("coShopId", params.coShopId);
  formData.append("type", params.type);
  formData.append("amount", params.amount);
  formData.append("reason", params.reason);
  formData.append("updateBy", params.updateBy);
  fileRef && fileRef.length > 0 && formData.append("file", fileRef[0].originFileObj);

  return await httpClient
    .post(`${baseUrl}/co-management/quota-adjustment`, formData, {
      params: { updateBy: params.updateBy },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const excelMutiCo = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/co-management/export-excel-shop`, params, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const excelMutiCoAccounting = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/co-management/export-excel-shop-accounting`, params, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const excelMutiCoList = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/co-management/export-excel-co`, params, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
//#endregion

const getCoDiscountDashboard = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/co-management/dashboard`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const excelMutiCoDashboard = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/co-management/dashboard/export`, params, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export {
  getCoDiscoutType,
  createCoDiscoutType,
  getCoDiscoutTypeById,
  updateCoDiscoutType,
  deleteCoDiscoutTypeById,
  checkCodeColor,
  checkCodeCOType,
  getUseageSummary,
  getUseageById,
  getCreditMemosById,
  createCoDiscoutList,
  getCoDiscountList,
  getCoDiscountSummary,
  getCoDiscountById,
  createCoAttachment,
  getCoAttachment,
  deleteCoDiscoutListById,
  getDetailCoDiscountById,
  getDetailShopById,
  getDetailProductById,
  getDetailHistoryById,
  getDetailAdjustById,
  getCoDiscountHistoryById,
  updateCoDiscoutList,
  checkCoConflicts,
  updateStatusShopWithRemark,
  updateStatusMainWithRemark,
  getCoDiscountEachShop,
  getCoSummaryEachShop,
  getShopCoListByShopId,
  getDetailShopCoByCusComId,
  getDetailShopCoList,
  getDetailShopHistoryList,
  getDetailShopAdjustmentList,
  createAdjustCoShop,
  deleteAttachmentById,
  excelMutiCo,
  excelMutiCoAccounting,
  excelMutiCoList,
  getCoDiscountDashboard,
  excelMutiCoDashboard,
};
